var render = function render(){var _vm=this,_c=_vm._self._c;return _c('narrative-source',_vm._b({attrs:{"collection":""}},'narrative-source',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }